import { CalendarOutlined } from '@ant-design/icons'
import { Button, Calendar } from 'antd'
import { groupBy } from 'lodash'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { AppHeader, ColumnLayout } from '@/components'
import { useGetMonthlyEventsQuery, useGetViewerQuery, useUpdateEventReadTimestampMutation } from '@/generated/graphql'

import { EventPostModal } from '../post/event-post/event-post-modal.component'
import { MyEventModal } from '../post/event-post/my-event-modal.component'
import s from './calendar.module.less'
import { DateCell } from './cell/date-cell.component'
import { CalendarHeader, HeaderConfigProps } from './header/calendar-header.component'

export const CalendarContainer: React.FC = () => {
  const dateFormat = 'YYYY-MM-DD'
  const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss'
  const { t } = useTranslation()
  const [date, setDate] = React.useState(moment())
  const { data: viewerData } = useGetViewerQuery()

  const { data } = useGetMonthlyEventsQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
    variables: {
      startDate: date.clone().startOf('month').format(dateTimeFormat),
      endDate: date.clone().endOf('month').format(dateTimeFormat),
    },
  })

  const [updateEventReadTimestamp] = useUpdateEventReadTimestampMutation()

  React.useEffect(() => {
    if (viewerData && viewerData.viewer.hasUnReadEvent) {
      updateEventReadTimestamp()
    }
  }, [viewerData])

  const headerRender = ({ value, type, onChange, onTypeChange }: HeaderConfigProps<moment.Moment>) => {
    return <CalendarHeader value={value} type={type} onChange={onChange} onTypeChange={onTypeChange} />
  }

  const dateCellRender = (date: moment.Moment) => {
    const formatDate = date.format(dateFormat)
    const data = groupedEvents[formatDate]
    return data ? <DateCell data={data} date={formatDate} /> : null
  }

  const events = data?.events.edges.map(({ node }) => node) || []

  const groupedEvents = groupBy(events, (event) => moment(event.startTime).format(dateFormat))

  const actions = (
    <div>
      <MyEventModal>
        <Button type='primary'>{t('viewer.event.title')}</Button>
      </MyEventModal>
      <EventPostModal>
        <Button type='primary' style={{ marginLeft: 8 }}>
          {t('post.event.title')}
        </Button>
      </EventPostModal>
    </div>
  )

  const header = (
    <AppHeader title={t('calendar.name')} avatar={<CalendarOutlined style={{ fontSize: 24 }} />} actions={actions} />
  )

  const content = (
    <div className={s.container}>
      <Calendar
        value={date}
        headerRender={headerRender}
        dateCellRender={dateCellRender}
        onSelect={(date) => setDate(date)}
        disabledDate={(currentDate) =>
          !currentDate.isBetween(
            date.clone().startOf('month').format(dateFormat),
            date.clone().endOf('month').format(dateFormat),
            'd',
            '[]'
          )
        }
      />
    </div>
  )
  return <ColumnLayout header={header} middle={content} />
}
